import { IEmpresaResponse } from "@/services/contabil/shared/requests/types";
import { injectable } from "inversify";
import "reflect-metadata";

export enum TipoEmpecilho {
  None = 0,
  Mfa = 1,
  CertificadoRevogado = 2,
  CpfDiferente = 3,
  CaixaPostal = 4,
  ConfiabilidadePrataOuro = 8,
  DadosAutenticacaoInvalidos = 9,
  CertificadoOutraEmpresa = 10
}

export interface ITipoEmpecilhoResponse {
  mensagem?: string;
  tipoEmpecilho: TipoEmpecilho;
  dataEmpecilho?: string;
}

export interface IEmpecilhosItemResponse extends IEmpresaResponse {
  empecilho?: ITipoEmpecilhoResponse;
  certificadoInvalido: false;
}

export interface IEmpecilhosResponse {
  empecilhos: IEmpecilhosItemResponse[];
}

@injectable()
export default class Empecilhos {
  protected response: IEmpecilhosResponse | undefined;

  setResponse(response: IEmpecilhosResponse | undefined) {
    this.response = response;
  }

  getEmpresasComEmpecilhos(empresaId?: string) {
    if (!empresaId)
      return (
        this.response?.empecilhos.filter(
          (empresa) =>
            empresa.empecilho &&
            empresa.empecilho.tipoEmpecilho != TipoEmpecilho.None
        ) || []
      );

    const empresa = this.response?.empecilhos.find(
      (empresa) =>
        empresa.id === empresaId &&
        empresa.empecilho?.tipoEmpecilho != TipoEmpecilho.None
    );

    if (!empresa) return [];

    return [empresa];
  }

  hasEmpresasComEmpecilhos(empresaId?: string) {
    return this.getEmpresasComEmpecilhos(empresaId).length > 0;
  }

  getEmpresasComDuploFator(empresaId?: string) {
    return this.getEmpresasComEmpecilhos(empresaId).filter(
      (empresa) => empresa.empecilho?.tipoEmpecilho === TipoEmpecilho.Mfa
    );
  }

  getEmpresasComConfiabilidadePrataOuro(empresaId?: string) {
    return this.getEmpresasComEmpecilhos(empresaId).filter(
      (empecilho) =>
        empecilho.empecilho?.tipoEmpecilho ===
        TipoEmpecilho.ConfiabilidadePrataOuro
    );
  }

  getEmpresasComDadosAutenticacaoInvalidos(empresaId?: string) {
    return this.getEmpresasComEmpecilhos(empresaId).filter(
      (empecilho) =>
        empecilho.empecilho?.tipoEmpecilho ===
        TipoEmpecilho.DadosAutenticacaoInvalidos
    );
  }

  getEmpresasComMensagensCaixaPostal(empresaId?: string) {
    return this.getEmpresasComEmpecilhos(empresaId).filter(
      (item) => item.empecilho?.tipoEmpecilho === TipoEmpecilho.CaixaPostal
    );
  }

  hasEmpresasComDuploFator(empresaId?: string) {
    return this.getEmpresasComDuploFator(empresaId).length > 0;
  }
}
